export const HISTORY_INDEX_KEY = "deltalightHistoryIndex" as const;
